import TableInfo from "@/interfaces/table.interface";

export const routineStatusTable: TableInfo[] = [
  {
    header: "Título",
    field: "name",
    type: "text",
  },
  {
    header: "Status",
    field: "state",
    type: "text",
  },
  {
    header: "Prioridade",
    field: "priority",
    type: "text",
  },
];
